import { logger } from '../core/logger'
import { GAME_TITLE } from '../ui/config'

function overlay(): HTMLElement {
  const el = document.getElementById('overlay')
  if (!el) throw new Error('#overlay missing from index.html')
  return el
}

const CONTROLS_HINT =
  'WASD thrust · Space/C up/down · Q/E roll · Shift boost · LMB/RMB fire · T target · Z flight assist · V camera · Esc/P menu (controls, settings)'

export function showStartOverlay(subtitle: string, onStart: () => void): void {
  const el = overlay()
  el.innerHTML = `<div class="panel ecl-start"><h1 id="overlay-title"></h1><p id="overlay-subtitle"></p><button id="start-button">Click to fly</button><p class="small">${CONTROLS_HINT}</p></div>`
  const title = el.querySelector('#overlay-title')
  if (title) title.textContent = GAME_TITLE.toUpperCase()
  const sub = el.querySelector('#overlay-subtitle')
  if (sub) sub.textContent = subtitle
  el.hidden = false
  el.querySelector('#start-button')?.addEventListener(
    'click',
    () => {
      el.hidden = true
      onStart()
    },
    { once: true },
  )
}

/** Boot progress on the start overlay: `done` of `total` assets, `label` = the last one finished. */
export function showLoading(done: number, total: number, label: string): void {
  const el = overlay()
  let bar = el.querySelector<HTMLElement>('#loading-bar')
  let text = el.querySelector<HTMLElement>('#loading-label')
  if (!bar || !text) {
    el.innerHTML = `<div class="panel"><h1 id="overlay-title"></h1><p>Loading assets</p><div class="loading-track"><div class="loading-bar" id="loading-bar"></div></div><p class="small" id="loading-label"></p></div>`
    bar = el.querySelector<HTMLElement>('#loading-bar')
    text = el.querySelector<HTMLElement>('#loading-label')
    const title = el.querySelector('#overlay-title')
    if (title) title.textContent = GAME_TITLE.toUpperCase()
  }
  const fraction = total > 0 ? done / total : 1
  if (bar) bar.style.transform = `scaleX(${fraction.toFixed(3)})`
  if (text) text.textContent = `${done} / ${total} · ${label}`
  el.hidden = false
}

/** Hides whatever the overlay shows (start, pause, loading). */
export function hideOverlay(): void {
  overlay().hidden = true
}

export function showMessage(title: string, body: string, action?: { label: string; onClick: () => void }): void {
  const el = overlay()
  el.innerHTML = `<div class="panel"><h1 id="msg-title"></h1><p id="msg-body"></p></div>`
  const panel = el.querySelector('.panel')
  const titleEl = el.querySelector('#msg-title')
  const bodyEl = el.querySelector('#msg-body')
  if (titleEl) titleEl.textContent = title
  if (bodyEl) bodyEl.textContent = body
  if (action && panel) {
    const button = document.createElement('button')
    button.textContent = action.label
    button.addEventListener('click', action.onClick, { once: true })
    panel.append(button)
  }
  el.hidden = false
}

export function showError(err: unknown): void {
  const message = err instanceof Error ? `${err.message}\n\n${err.stack ?? ''}` : String(err)
  logger.error('Fatal error', err)
  const el = overlay()
  el.innerHTML = `<div class="panel error"><h1>Something broke</h1><pre id="error-text"></pre><button id="copy-error">Copy error</button><button id="reload">Reload</button></div>`
  const pre = el.querySelector('#error-text')
  if (pre) pre.textContent = message
  el.querySelector('#copy-error')?.addEventListener('click', () => {
    navigator.clipboard.writeText(message).catch((clipErr: unknown) => logger.warn('Clipboard write failed', clipErr))
  })
  el.querySelector('#reload')?.addEventListener('click', () => location.reload(), { once: true })
  el.hidden = false
}
